import posthog from 'posthog-js'
import { filterIgnoredExceptions } from '@/lib/posthogExceptionFilter'

const key = import.meta.env.VITE_POSTHOG_KEY
const apiHost =
  import.meta.env.VITE_POSTHOG_API_HOST || import.meta.env.VITE_POSTHOG_HOST
const uiHost = import.meta.env.VITE_POSTHOG_UI_HOST || 'https://eu.posthog.com'
const enabled =
  import.meta.env.VITE_POSTHOG_ENABLED === 'true' || import.meta.env.PROD

export function initPostHog() {
  if (!key || !apiHost || !enabled) return

  posthog.init(key, {
    api_host: apiHost,
    ui_host: uiHost,
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_exceptions: true,
    disable_session_recording: false,
    debug: import.meta.env.DEV,
    before_send: filterIgnoredExceptions,
  })
}

export { posthog }
